export const settings = {
  xdebug_key: process.env.REACT_APP_TYPE !== "live_build",
  log_network: process.env.REACT_APP_TYPE !== "live_build",
  subfolder: "/pwa/offline",
  url:
    process.env.NODE_ENV === "development"
      ? "http://localhost"
      : window.urlconf
      ? window.urlconf
      : process.env.REACT_APP_TYPE === "local_build"
      ? "http://localhost:8080"
      : process.env.REACT_APP_TYPE === "demo_build"
      ? "https://demo.jetfuelqc.com"
      : process.env.REACT_APP_TYPE === "live_build"
      ? "https://www.jetfuelqc.com"
      : "http://jetfuel.test",
};
